module.exports = __webpack_public_path__ + "static/media/app_store_badge@3x.77a2ab97.png";